import { app } from '../../../app';
import { resolve } from '../../../init/store';
import { lazyLoad } from '../../../lib/lazy-load';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application', {
        url: '/application/:appId',
        redirectTo: 'company.manage-application.configuration',
        views: {
            '@company': 'companyManageApplication',
        },
        resolve: {
            $breadcrumbs,
            appId,
            application,
            companyDomains,
            credentials$,
        },
    });
}

/** @ngInject */
function $breadcrumbs(application) {
    const title = {
        // getter to allow dynamic updates
        get title() {
            return application.applicationName
        }
    };

    if (application.applicationType.slug === 'computer-login') {
        return [{stateName: 'company.computer-protection'}, title];
    }
    if (application.applicationType.slug === 'computer-protection-without-ad') {
        return [{stateName: 'company.computer-protection'}, title];
    }
    if (application.applicationType.slug === 'custom') {
        return [{stateName: 'company.custom-app-integration'}, title];
    }
    return [{stateName: 'company.applications'}, title];
}

/** @ngInject */
function appId($stateParams) {
    return $stateParams.appId;
}

/** @ngInject */
function application(companyId, appId, ApplicationsResource) {
    return ApplicationsResource
        .getApplicationConfiguration(companyId, appId)
        .then(app => {
            [app]
                .filter(app => app.epmAppSettings)
                .filter(app => app.epmAppSettings.publicService.slug === 'other')
                .forEach(app => app.epmAppSettings.publicService.serviceName = 'Custom');
            return app;
        })
}

/** @ngInject */
function companyDomains(application, companyId, DomainsService) {
    if (application.applicationType.slug === 'office-365') {
        return DomainsService.query({companyId}).$promise
            .then((domains) => domains.map(({id, domainName}) => ({domainId: id, domainName})))
    }
}

/** @ngInject */
function credentials$(application, ApplicationsResource, companyId, DestructiveOperationModal) {
    return resolve.credentials$ = lazyLoad(() => DestructiveOperationModal({
        titleKey: 'company.manage-application.integration-developers.app-key-password.destructive.title',
        textKey: 'company.manage-application.integration-developers.app-key-password.destructive.text',
        onSubmit: params => ApplicationsResource.getApplicationApiCredentials(companyId, application.id, params)
    })).map(v => {
        const credentials = {
            applicationApiKey: v.applicationKey,
            applicationApiPassword: v.applicationPassword,
        };
        Object.assign(application, credentials);
        return credentials;
    })
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/manage-application.state.js